import { useState, useEffect, memo } from 'react';
import { Link } from 'react-router-dom';
import { ButtonToolbar, OverlayTrigger, Popover } from "react-bootstrap";
import axiosAWS from '../../api/configAxios.js';
import Cookie from "js-cookie";
import Swal from 'sweetalert2';

const RoLinkFav = (params) => {

    const [LoadDelete, setLoadDeleteo] = useState(false);

    const popoverHoverFocus = (texto) => {
        return (
            <Popover className="p-2" id="popover-trigger-hover-focus" title="Popover bottom">
                {texto}
            </Popover>
        );
    }

    const get_data_consulta = async (url, data) => {
        var result = null;
        try {
            const cookies = Cookie.get();
            var result_auth = null;

            result_auth = await axiosAWS.post(url, data, { headers: { 'Authorization': `Bearer ${cookies.AutKeyPbi}` } }).catch(function (error) {
                if (error.response.status === 400) {
                   //console.log("error 400");
                }

                if (error.response.status >= 500) {
                    //console.log("algo anda mal con la el servidor");
                }
            });

            //console.log(result_auth);

            if (result_auth.status >= 200 || result_auth.status <= 299) {
                if (result_auth.data.hasOwnProperty("result")) {
                    if (result_auth.data.result !== null) {
                        result = result_auth.data.result;

                    } else {
                        alert("sin datos presentes");
                    }

                }

            } else {
                alert("usuario denegado");
            }

            return result;
        } catch (error) {

           //console.log("error servidorAWS");
            return "error";
        }
    }

    ///delete
    const delete_element = async () => {
        setLoadDeleteo(true)
       //console.log({ type: "Tfavorito", uuid: params.fv.uuid_tablero });
        var result_insert = await get_data_consulta("panel-control/delete-element", { type: "Tfavorito", uuid_tablero: params.fv.uuid_tablero });
       //console.log(result_insert)
        if (result_insert === "error") {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al intentar eliminar el registro');
            setLoadDeleteo(false);
            return
        }
        if (!result_insert.hasOwnProperty("affectedRows")) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: 'existio un error al cargar el registro',
                timer: 4000
            });
            //alert('existio un error al intentar eliminar el registro');
            setLoadDeleteo(false);
            return
        }

        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            title: 'Exito',
            text: 'Tablero eliminado de tus favoritos',
            timer: 4000
        });
        //alert("tablero eliminado de tus favoritos")
        setLoadDeleteo(false);
       //console.log(result_insert)
        document.getElementById('fv_u_' + params.fv.uuid_tablero).remove();


    }

    return (
        //<div className='list-group-item' key={"fv-" + params.fv.titulo_tablero}>
        <div className='list-group-item' id={'fv_u_' + params.fv.uuid_tablero}>
            {
                LoadDelete ?
                    <>
                        enviando...
                    </>
                    :
                    <>
                        <Link to={("/tablero?tbl=" + params.fv.uuid_gtableros + "|" + params.fv.uuid_tablero)} type="button" className='tdec-none' > {params.fv.titulo} <i className="bi bi-box-arrow-up-right"></i></Link>
                        <div className='popover_mo me-1'>
                            <i className="bi bi-trash3-fill" onClick={() => { delete_element() }}></i>
                        </div>
                        <div className='popover_mo me-4_5'>

                            <ButtonToolbar>
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="top"
                                    overlay={popoverHoverFocus(params.fv.nota)}
                                >
                                    <i className="bi bi-info-circle"></i>
                                </OverlayTrigger>
                            </ButtonToolbar>
                        </div>
                    </>
            }

        </div>
    );

}

export default memo(RoLinkFav);

